import { render } from "./SelectedBank.vue?vue&type=template&id=58dcc7ec"
import script from "./SelectedBank.vue?vue&type=script&lang=js"
export * from "./SelectedBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__